<template>
  <div>
    <el-dialog
      :title="selfData.id ? '编辑仓库' : '新增仓库'"
      width="680px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <e-form ref="refForm" :config="formConfig" :column="formColumn" :data.sync="selfData" />
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {
        id: '',
        warehouse_name: '',
        warehouse_code: '',
        warehouse_type: 1,
        address: '',
        manager: '',
        phone: '',
        status: 1,
        remark: '',
        deleted: false
      },
      formConfig: {
        inline: true,
        width: '300px'
      }
    }
  },
  computed: {
    formColumn() {
      return [
        { type: 'text', title: '仓库名称', field: 'warehouse_name', required: true, placeholder: '请输入仓库名称' },
        { type: 'text', title: '仓库编码', field: 'warehouse_code', disabled: true, placeholder: '保存后自动生成' },
        {
          type: 'select',
          title: '仓库类型',
          field: 'warehouse_type',
          options: [
            { key: '普通仓', val: 1 },
            { key: '退货仓', val: 2 },
            { key: '虚拟仓', val: 3 },
            { key: '中转仓', val: 4 }
          ]
        },
        { type: 'text', title: '地址', field: 'address' },
        { type: 'text', title: '负责人', field: 'manager' },
        { type: 'text', title: '电话', field: 'phone' },
        {
          type: 'select',
          title: '状态',
          field: 'status',
          options: [
            { key: '启用', val: 1 },
            { key: '停用', val: 0 }
          ]
        },
        { type: 'text', title: '备注', field: 'remark' }
      ]
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.id) {
      this.getDetailData()
    }
  },
  methods: {
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/newWarehouse/getById',
        params: { id: this.id }
      }).then((res) => {
        if (res.status === 200 && res.data.formData) {
          const fd = res.data.formData
          this.selfData = {
            id: fd.id || '',
            warehouse_name: fd.warehouse_name || '',
            warehouse_code: fd.warehouse_code || '',
            warehouse_type: fd.warehouse_type === null || fd.warehouse_type === undefined ? 1 : Number(fd.warehouse_type),
            address: fd.address || '',
            manager: fd.manager || '',
            phone: fd.phone || '',
            status: fd.status === null || fd.status === undefined ? 1 : Number(fd.status),
            remark: fd.remark || '',
            deleted: false
          }
        }
      })
    },
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    popupConfirm() {
      if (!this.selfData.warehouse_name) {
        this.$message.warning('请填写仓库名称')
        return
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/newWarehouse/saveOrUpdate',
        data: { form_data: this.selfData }
      })
        .then((res) => {
          if (res.data.state !== 'fail') {
            this.$message.success('保存成功')
            this.popupCancel()
            this.$emit('success')
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  padding: 10px 0;
}
</style>
